export default {
  meta: {
    title: '标签管理',
  },
};
